<div class="ig-loading-dot">
  <div *ngIf="tip" class="mb-1">{{tip}}</div>
  <div class="ig-loading-dot-wrap">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
